import React from 'react'
import { useLocation } from 'react-router'

import { Tab } from '../../../design-system/Tab'
import { useBotId } from '../../../../store/flow'
import { DisableableLink } from '../../../Styleguide/DisableableLink'

export const WizardTab: React.FC = () => {
  const botId = useBotId()
  const location = useLocation()

  const wizardHref = `/bots/${botId}/wizard`
  const isWizardInHref = location.pathname.includes('/wizard')

  return (
    <DisableableLink key="wizard-tab" to={wizardHref}>
      <Tab size={18} label="Wizard" active={isWizardInHref} />
    </DisableableLink>
  )
}
